import { useFormContext } from 'react-hook-form';
import { CatalogCategoryFormState } from './catalogFormValues';
import { CatalogFormSection } from './CatalogFormSection';
import { CatalogFormField } from './CatalogFormField';

export function CategoryIdentitySection() {
  const { register, formState: { errors } } = useFormContext<CatalogCategoryFormState>();
  return <CatalogFormSection id="identity" title="Основное" description="Помогите быстро понять, какие товары входят в эту категорию.">
    <CatalogFormField name="category_name" label="Название" error={errors.category_name?.message}>
      <input id="category_name" {...register('category_name', { required: 'Укажите название', validate: (value) => value.trim() !== '' || 'Укажите название' })} aria-invalid={Boolean(errors.category_name)} aria-describedby={errors.category_name ? 'category_name-error' : undefined} />
    </CatalogFormField>
    
    <CatalogFormField name="category_description" label="Описание" error={errors.category_description?.message}>
      <textarea id="category_description" rows={4} {...register('category_description')} aria-invalid={Boolean(errors.category_description)} aria-describedby={errors.category_description ? 'category_description-error' : undefined} />
    </CatalogFormField>
  </CatalogFormSection>;
}
